import React, { useState, useEffect } from "react";
import axios from "axios";
import MiniDrawer from "../MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";

const baseAPI = process.env.REACT_APP_API_URL + "/";
const baseImageURL = process.env.REACT_APP_IMAGE_URL;


const SalesSummary = () => {
  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-[14px] h-[14px] opacity-50"
    >
      <path d="m21 16-4 4-4-4"></path>
      <path d="M17 20V4"></path>
      <path d="m3 8 4-4 4 4"></path>
      <path d="M7 4v16"></path>
    </svg>
  );

  const [openMonth, setOpenMonth] = useState("MARCH");

  // ✅ API STATES
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [monthDetails, setMonthDetails] = useState({});
  const [mode, setMode] = useState("Executed");
  const [year, setYear] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  const navigate = useNavigate();
  const handleSort = (key, monthNumber) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });

    const sortedData = [...(monthDetails[monthNumber] || [])].sort((a, b) => {
      let valA = a[key];
      let valB = b[key];

      // handle numbers + strings
      if (!isNaN(valA) && !isNaN(valB)) {
        return direction === "asc" ? valA - valB : valB - valA;
      } else {
        return direction === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      }
    });

    setMonthDetails((prev) => ({
      ...prev,
      [monthNumber]: sortedData,
    }));
  };

  // ✅ progress color function (same as yours)
  const getProgressColor = (value) => {
    const val = Number(value);
    if (val === 100) return "#4CAF50";
    if (val >= 50) return "#F5A623";
    return "#E53935";
  };

  const getFinancialYears = () => {
    const startYear = 2020;
    const currentYear = new Date().getFullYear();

    let years = [];

    for (let i = startYear; i <= currentYear; i++) {
      years.push(`${i}-${i + 1}`);
    }

    return years.reverse(); // latest first
  };
  // ✅ AUTH
  const getAuthConfig = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  // ✅ MONTHLY DATA
  const fetchMonthlyData = async () => {
    try {
      const res = await axios.get(
        `${baseAPI}userget/SalesSummary_Monthly?FinancialYear=${year}&Mode=${mode}&StatusFilter=All&ServiceFilter=All`,
        getAuthConfig(),
      );

      if (res.data.status === "True") {
        const formatted = res.data.data.map((item) => ({
          month: item.MonthName.toUpperCase(),
          conversions: item.Conversions,
          executions: item.Executions,
          sales: item.TotalSales,
          cogs: item.TotalCOGS,
          gp: item.GrossProfit,
          gpPercent: item.GrossProfitPct + "%",
          monthNumber: item.MonthNumber,
          estimate_attachment: item.estimate_attachment,
        }));

        setData(formatted);
      }
    } catch (err) {
      console.log("Monthly Error:", err);
    }
  };

  // ✅ YEAR SUMMARY
  const fetchSummary = async () => {
    try {
      const res = await axios.get(
        `${baseAPI}userget/SalesSummaryYearTotal?FinancialYear=${year}&Mode=${mode}&StatusFilter=All&ServiceFilter=All`,
        getAuthConfig(),
      );

      if (res.data.status === "True") {
        setSummary(res.data.data[0]);
      }
    } catch (err) {
      console.log("Summary Error:", err);
    }
  };

  // ✅ MONTH DETAILS
  const fetchMonthDetails = async (monthNumber) => {
    try {
      const res = await axios.get(
        `${baseAPI}userget/SalesSummaryMonthDetail?FinancialYear=${year}&MonthNumber=${monthNumber}&Mode=${mode}&StatusFilter=All&ServiceFilter=All`,
        getAuthConfig(),
      );

      if (res.data.status === "True") {
        const rows = res.data.data.map((row) => ({
          id: row.LeadID,
          date: new Date(row.DisplayDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          name: row.CustomerName,
          service: row.ServiceType,
          estimate: row.EstimateAmount,
          receipts: row.PaymentReceiptCount,
          expense: row.Expense,
          profit: row.GrossProfit,
          grossProfitPercentage: row.GrossProfitPct + "%",
          estimate_attachment: row.estimate_attachment,
          relocation_id: row.LeadID,
          payment: row.PaymentStatusPct,
          status: row.Status,
          payment_received: row.payment_received,
          billingName: row.billingName,
          panNumber: row.panNumber,
          panDocName: row.panDocName,
          gst_number: row.gst_number,
          gstDocName: row.gstDocName
          
        }));

        setMonthDetails((prev) => ({
          ...prev,
          [monthNumber]: rows,
        }));
      }
    } catch (err) {
      console.log("Month Details Error:", err);
    }
  };
  useEffect(() => {
    const years = getFinancialYears();

    if (years.includes("2025-2026")) {
      setYear("2025-2026");
    } else {
      const current = new Date().getFullYear();
      setYear(`${current}-${current + 1}`);
    }
  }, []);

  // ✅ LOAD ON START
  useEffect(() => {
    if (!year) return;

    fetchMonthlyData();
    fetchSummary();
    setMonthDetails({});
    setOpenMonth(null);
  }, [year, mode]);



  function nextPage(Relocation_ID) {
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/ViewShipmentDetail?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, "_blank");
  }

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      Relocation_ID.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }










  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />

        <div
          style={{ overflowX: "hidden" }}
          className="container-fluid container-viewLeadDetails"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            }}
            className="country-header"
          >
            <div>
              <h1 style={{ fontSize: "24px" }}>
                <b> Accounts & Finance </b> | <HomeOutlinedIcon /> &gt;
                <a style={{ cursor: "pointer" }}>Sales Register </a>
                <span style={{ fontSize: "20px" }}>&gt; Sales Summary</span>
              </h1>
            </div>
          </div>

          <div className="">
            {/* Header */}
            <div className="header">Sales Summary</div>

            <div className="card">
              {/* Filters */}
              <div className="top-bar">
                <div className="filters">
                  <select
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                  >
                    {getFinancialYears().map((yr, index) => (
                      <option key={index} value={yr}>
                        {yr}
                      </option>
                    ))}
                  </select>
                  <select
                    value={mode}
                    onChange={(e) => setMode(e.target.value)}
                  >
                    <option>Executed</option>
                    <option>Booking</option>
                  </select>
                </div>

                {/* ✅ SUMMARY */}
                <div className="summary">
                  <span className="pill purple">
                    Sales: <b>₹ {summary?.TotalSales?.toLocaleString()}</b>
                  </span>
                  <span className="pill red">
                    COGS: <b>₹ {summary?.TotalCOGS?.toLocaleString()}</b>
                  </span>
                  <span className="pill green1">
                    GP: <b>₹ {summary?.TotalGrossProfit?.toLocaleString()}</b>
                  </span>
                  <span className="pill dark">
                    TOTAL: <b>{summary?.TotalLeads}</b>
                  </span>
                </div>
              </div>

              {/* Month Section */}
              {data.map((item, index) => {
                const isOpen = openMonth === item.month;

                return (
                  <div className="month-card1" key={index}>
                    <div
                      className="month-header"
                      onClick={() => {
                        setOpenMonth(isOpen ? null : item.month);

                        if (!monthDetails[item.monthNumber]) {
                          fetchMonthDetails(item.monthNumber);
                        }
                      }}
                    >
                      {/* LEFT + CENTER */}
                      <div className="month-left">
                        {/* Month Box */}
                        <div className="month-title">{item.month}</div>

                        {/* Metrics */}
                        <div className="month-metrics">
                          <div className="metric">
                            <span>Conversions</span>
                            <b>{item.conversions}</b>
                          </div>

                          <div className="metric">
                            <span>Executions</span>
                            <b>{item.executions}</b>
                          </div>

                          <div className="metric">
                            <span>Sales</span>
                            <b>₹ {item.sales?.toLocaleString()}</b>
                          </div>

                          <div className="metric red">
                            <span>COGS</span>
                            <b>₹ {item.cogs?.toLocaleString()}</b>
                          </div>

                          <div className="metric green1">
                            <span>G.P</span>
                            <b>₹ {item.gp?.toLocaleString()}</b>
                          </div>

                          <div className="metric">
                            <span className="gp-pill">{item.gpPercent}</span>
                          </div>
                        </div>
                      </div>

                      {/* RIGHT BUTTON */}
                      <div className="toggle-btn">
                        <svg
                          className={`chevron ${isOpen ? "rotate" : ""}`}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path d="m6 9 6 6 6-6"></path>
                        </svg>
                      </div>
                    </div>

                    {isOpen && (
                      <div className="table-wrapper mb-3">
                        <table>
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th
                                onClick={() =>
                                  handleSort("id", item.monthNumber)
                                }
                              >
                                Lead ID <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("date", item.monthNumber)
                                }
                              >
                                Execution Date <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("name", item.monthNumber)
                                }
                              >
                                Customer Name <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("billingName", item.monthNumber)
                                }
                              >
                                Billing Name <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>
                              <th
                                onClick={() =>
                                  handleSort("panCard", item.monthNumber)
                                }
                              >
                                PAN No. <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>
                              <th
                                onClick={() =>
                                  handleSort("gstNo", item.monthNumber)
                                }
                              >
                                GST No. <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>
                              <th
                                onClick={() =>
                                  handleSort("panDoc", item.monthNumber)
                                }
                              >
                                PAN Doc <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>
                              <th
                                onClick={() =>
                                  handleSort("gstDoc", item.monthNumber)
                                }
                              >
                                GST Doc <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>
                              <th
                                onClick={() =>
                                  handleSort("service", item.monthNumber)
                                }
                              >
                                Service Type <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>
                              <th
                                onClick={() =>
                                  handleSort("estimate", item.monthNumber)
                                }
                              >
                                Estimate Amount <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("receipts", item.monthNumber)
                                }
                              >
                                Payment Receipt <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("expense", item.monthNumber)
                                }
                              >
                                Expense <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("profit", item.monthNumber)
                                }
                              >
                                Gross Profit <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("payment", item.monthNumber)
                                }
                              >
                                Payment Status <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("status", item.monthNumber)
                                }
                              >
                                Status <span className="descasc" style={{ cursor: "pointer" }}>{icon}</span>
                              </th>
                            </tr>
                          </thead>

                          <tbody className="tbody_tr">
                            {(monthDetails[item.monthNumber] || []).map(
                              (row, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td> <a onClick={() => nextPage(row.id)}> <b>{row.id}</b></a></td>
                                  <td>{row.date}</td>
                                  <td>{row.name}</td>
                                  <td>{row.billingName}</td>
                                  <td>{row.panNumber}</td>
                                  <td>{row.gst_number}</td>
                                  <td>
                                    {row.panDocName ? (
                                      <span
                                        className="nevigation_svg"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          window.open(`${baseImageURL}/Images/Documents/${row.id}/${row.panDocName}`, "_blank");
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="lucide lucide-external-link w-[14px] h-[14px] text-[#5b489d]"
                                        >
                                          <path d="M15 3h6v6"></path>
                                          <path d="M10 14 21 3"></path>
                                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                        </svg>
                                      </span>
                                    ) : null
                                    }
                                  </td>
                                  <td>
                                    {row.gstDocName ? (
                                      <span
                                        className="nevigation_svg"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          window.open(`${baseImageURL}/Images/Documents/${row.id}/${row.gstDocName}`, "_blank");
                                        }}
                                      >

                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="lucide lucide-external-link w-[14px] h-[14px] text-[#5b489d]"
                                        >
                                          <path d="M15 3h6v6"></path>
                                          <path d="M10 14 21 3"></path>
                                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                        </svg>

                                      </span>
                                    ) : null
                                    }
                                  </td>
                                  <td>{row.service}</td>
                                  <td>
                                    ₹ {row.estimate?.toLocaleString()}
                                    <span
                                      className="nevigation_svg"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {

                                        if (row.estimate_attachment) {
                                          window.open(`${baseImageURL}/Images/Documents/${row.id}/${row.estimate_attachment}`, "_blank");
                                        } else {
                                          alert("No attachment available");
                                        }
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-external-link w-[14px] h-[14px]"
                                      >
                                        <path d="M15 3h6v6"></path>
                                        <path d="M10 14 21 3"></path>
                                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                      </svg>
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      cursor: "pointer",
                                      color: "#5b489d",
                                      fontWeight: "500",
                                    }}
                                    onClick={() => {
                                      const encodedId = btoa(
                                        row.relocation_id.toString(),
                                      ); // encode
                                      const url = `/PaymentReceipt1?id=${encodedId}`;
                                      window.open(url, "_blank");
                                    }}
                                  >
                                    {row.payment_received} ( {row.receipts} Receipts )
                                  </td>

                                  <td
                                    style={{
                                      cursor: "pointer",
                                      color: "#5b489d",
                                      fontWeight: "500",
                                    }}
                                    onClick={() => {
                                      console.log("Clicked Row 👉", row);

                                      if (!row.relocation_id) {
                                        alert("Relocation ID missing!");
                                        return;
                                      }

                                      // optional fallback
                                      localStorage.setItem("relocationId", row.relocation_id,);

                                      // ✅ ENCODE ID
                                      const encodedId = btoa(
                                        row.relocation_id.toString(),
                                      );

                                      // ✅ OPEN IN NEW TAB
                                      const url = `/AccountsExpense?id=${encodedId}`;
                                      window.open(url, "_blank");
                                    }}
                                  >
                                    ₹ {row.expense?.toLocaleString()}
                                    <span className="nevigation_svg">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-external-link w-[14px] h-[14px] text-[#5b489d]"
                                      >
                                        <path d="M15 3h6v6"></path>
                                        <path d="M10 14 21 3"></path>
                                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                      </svg>
                                    </span>
                                  </td>

                                  <td>
                                    ₹ {row.profit?.toLocaleString()}
                                    <br />
                                    <span style={{ fontSize: "11px" }}>
                                      {row.grossProfitPercentage}
                                    </span>
                                  </td>

                                  <td>
                                    <div className="custom-progress">
                                      <div
                                        className="custom-progress-bar"
                                        style={{
                                          width: `${row.payment}%`,
                                          backgroundColor: getProgressColor(
                                            row.payment,
                                          ),
                                        }}
                                      />
                                    </div>
                                    <span className="percent-text">
                                      {row.payment}%
                                    </span>
                                  </td>

                                  <td>
                                    <span
                                      className={
                                        row.status === "Open"
                                          ? "status open"
                                          : "status close1"
                                      }
                                    >
                                      {row.status}
                                    </span>
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            {/* CSS */}
            <style>{`
// new Css
.month-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f3f1fa;
  border-radius: 10px;
  padding: 10px 15px;
  border: 1px solid #e3dcff;
}

/* LEFT SECTION */
.month-left {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 90%;
}

/* MONTH BOX */
.month-title {
  background: #e6e3f5;
  padding: 12px 18px;
  border-radius: 8px;
  font-weight: bold;
  color: #5b489d;
  min-width: 143.96px;
  text-align: center;
}

/* METRICS ROW */
.month-metrics {
  display: flex;
  align-items: center;
  gap: 50px;
  flex: 1;
  justify-content: flex-start;
}
.metric .gp-pill{
 position: relative;
    left: -61px;
}
/* EACH ITEM */
.metric {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  color: #666;
}
.metric {
  display: flex;
  flex-direction: column;
  min-width: 161px;   /* 👈 important for alignment */
}
.metric b {
  font-size: 20px;
  color: #5b489d;
      // padding-left: 12px;
}

/* COLORS */
.metric.red b {
  color: #e53935;
}

.metric.green1 b {
  color: #4caf50;
}
/* GP % FIX */
.gp-pill {
  margin-top: 22px;
  text-align: center;
  display: inline-block;
  min-width: 70px;
}
/* GP % BADGE */
.gp-pill {
 background: #4caf50;
    color: white;
    padding: 4px 8px !important;
    border-radius: 6px;
    font-size: 14px;
    margin-top: 33px;
}

/* BUTTON */
.toggle-btn {
  margin-left: 15px;
}
  .summary .red{
  background: #ffdada; 
  }

  .summary .green1{
  background: #d8ffd9;
   }

// new Css

            th {
  cursor: pointer;
}
            thead tr th{
            font-size: 13px
            }
            .estimate_nevigation{
            color: #5b489d;
            }
            .nevigation_svg svg
            {
            margin-left: 3px;
            width: 13px;
            }
            .tbody_tr tr:hover{
            background: #f8f7fc;
            }
            .tbody_tr tr{
            font-size: 13px;
            }
            .main_color{
            font-size: 12px;
            }
            .main_color b{
            color: #5b489d;
            font-size: 20px;
            }
            .red-text b{
             color: #5b489d;
              font-size: 20px;
            }
             .green1-text b{
             color: #5b489d;
              font-size: 20px;
             }
            .toggle-btn {
  background: #fff;
  border-radius: 10px;
  margin-top: 9px;
  box-shadow: 0px 0px 6px 3px rgba(91, 72, 157, 0.1);
  width: 45px;
  height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
}

.chevron {
  width: 20px;
  height: 20px;
  stroke: #6a6a6a;
  stroke-width: 2;
  fill: none;
  transition: transform 0.3s ease;
}

/* rotate when open */
.chevron.rotate {
  transform: rotate(180deg);
}
        body {
          font-family: Arial;
        }

        .container {
          padding: 20px;
          background: #f4f6fb;
        }

        .header {
          background: #5b4db1;
          color: white;
          padding: 12px;
          font-size: 18px;
          border-radius: 6px 6px 0 0;
        }

        .card {
          background: white;
          padding: 15px;
          border-radius: 0 0 6px 6px;
        }

        .top-bar {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-bottom: 15px;
        }

        .filters select {
          margin-right: 10px;
          padding: 6px;
              border-radius: 6px;
              font-size: 15px;
        }

        .summary .pill {
          padding: 6px 10px;
          border-radius: 6px;
          margin-right: 8px;
          font-size: 13px;
        }

        .purple { background: #eee9ff;color: #5b4db1 }
        .red {color: red; }
        .green1 {color: green; }
        .dark { background: #5b4db1; color: white; }

        .month-card {
          border: 1px solid #ddd;
          margin-bottom: 10px;
          border-radius: 6px;
          background: #fafafa;
        }

       .month-header {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  background: #f9f8fd;
  border-radius: 10px;
  border: 1px solid #e3dcff;
  margin-bottom: 12px;
  transition: all 0.2s ease;
}

/* ✅ hover on full card */
.month-header:hover {
  border: 1px solid #5b489d;
  box-shadow: 0 2px 8px rgba(91, 72, 157, 0.15);
}

        .month-left span {
          margin-right: 57px;
              // display: flex;
              padding: 10px 10px 0px 0px;
              flex-direction: column;
        }

        .month-title {
          background: white;
          font-size: 20px;
          padding: 15px 16px;
          border-radius: 10px;
          font-weight: bold;
          margin-right: 10px;
          color: #5b489d;
        }

        .red-text { color: red; }
        .green1-text { color: green; }

        .gp-badge {
           background: #4caf51;
           color: white;
           height: 29px;
           border-radius: 5px;
           margin-top: 24px;
           padding: 3px 8px !important;

        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
        }

        th {
          background: #5b4db1;
          color: white;
          padding: 8px;
        }

        td {
          padding: 8px;
          border-bottom: 1px solid #ddd;
        }

        .receipt {
          background: #eee9ff;
          padding: 4px 8px;
          border-radius: 5px;
        }

    .custom-progress {
  width: 120px;
  height: 7px;
  background: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
}

.custom-progress-bar {
  height: 100%;
  border-radius: 10px;
  display: block;
  min-width: 2px;
  transition: width 0.3s ease;
}

.percent-text {
  font-size: 12px;
  margin-left: 5px;
}

        // .progress {
        //   width: 100px;
        //   height: 6px;
        //   background: #ddd;
        //   border-radius: 5px;
        //   margin-bottom: 4px;
        // }

        // .progress-bar {
        //   height: 6px;
        //   background: orange;
        //   border-radius: 5px;
        // }

        .status {
          padding: 4px 8px;
          border-radius: 5px;
          font-size: 12px;
        }

        .open {
          background: #e6ffe6;
          color: green;
        }

        .close1 {
          background: #ffe5e5;
          color: red;
        }
      `}</style>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesSummary;
